import { newPageInfo, PageInfo } from "@hex-insights/router";
import { Student } from "../../../../Utilities";

export type DetailViewSubPageInfo = PageInfo<string, (id: Student["id"]) => string, { studentID: Student["id"] }>;

export type DetailViewSubPageInfos = {
	overview: DetailViewSubPageInfo;
	academics: DetailViewSubPageInfo;
	familyAndContact: DetailViewSubPageInfo;
	health: DetailViewSubPageInfo;
	financials?: DetailViewSubPageInfo;
	resources: DetailViewSubPageInfo;
};

export function newOverviewPageInfo(
	parent: PageInfo<any, (id: Student["id"]) => string, { studentID: Student["id"] }>,
) {
	return newPageInfo({
		name: "Student Detail Overview",
		title: "",
		description: "Overview page of the Student.",
		exact: true,
		to: parent.to,
		path: parent.path,
		parent: parent,
		paramsType: parent.paramsType,
	});
}

export function newAcademicsPageInfo(
	parent: PageInfo<any, (id: Student["id"]) => string, { studentID: Student["id"] }>,
) {
	return newPageInfo({
		title: "Academics",
		description: "Academic information for the Student.",
		exact: true,
		to: (id: Student["id"]) => parent.to(id) + "/academics",
		path: parent.path + "/academics",
		parent: parent,
		paramsType: parent.paramsType,
	});
}

export function newFamilyAndContactPageInfo(
	parent: PageInfo<any, (id: Student["id"]) => string, { studentID: Student["id"] }>,
) {
	return newPageInfo({
		title: "Family & Contact",
		description: "Family and contact information for the Student.",
		exact: true,
		to: (id: Student["id"]) => parent.to(id) + "/family-and-contact",
		path: parent.path + "/family-and-contact",
		parent: parent,
		paramsType: parent.paramsType,
	});
}

export function newHealthPageInfo(parent: PageInfo<any, (id: Student["id"]) => string, { studentID: Student["id"] }>) {
	return newPageInfo({
		title: "Health",
		description: "Health, allergy, and medication records for the Student.",
		exact: true,
		to: (id: Student["id"]) => parent.to(id) + "/health",
		path: parent.path + "/health",
		parent: parent,
		paramsType: parent.paramsType,
	});
}

export function newFinancialsPageInfo(
	parent: PageInfo<any, (id: Student["id"]) => string, { studentID: Student["id"] }>,
) {
	return newPageInfo({
		title: "Financials",
		description: "Financial information including contracts, invoices, and payments for the Student.",
		exact: true,
		to: (id: Student["id"]) => parent.to(id) + "/financials",
		path: parent.path + "/financials",
		parent: parent,
		paramsType: parent.paramsType,
	});
}

export function newResourcesPageInfo(
	parent: PageInfo<any, (id: Student["id"]) => string, { studentID: Student["id"] }>,
) {
	return newPageInfo({
		title: "Resources",
		description: "Resources, documents, folders, notes, and photos and images for the Student.",
		exact: true,
		to: (id: Student["id"]) => parent.to(id) + "/resources",
		path: parent.path + "/resources",
		parent: parent,
		paramsType: parent.paramsType,
	});
}
